import { WidgetsSection } from './WidgetsSection'

export default WidgetsSection
